import React from 'react'

import { BUTTON_TYPE, SIZE } from '@app/constants'

import { LntDivider } from '@app/components/base/Divider'
import { LntButton } from '@app/components/base/Button'

import styles from './style.module.scss'

import type { DropdownRenderProps } from '../types'

export const AcceptRender: React.FC<DropdownRenderProps> = ({ menu, onAccept }) => {
  return (
    <div className={ styles.dropdownRenderer }>
      { menu }
      <LntDivider />
      <LntButton
        type={ BUTTON_TYPE.secondary }
        size={ SIZE.small }
        onClick={ onAccept }
      >
        Применить
      </LntButton>
    </div>
  )
}
